import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Description.module.css';
import {
  GitHub,
  LinkedIn,
  Twitter,
} from '@material-ui/icons';

const Description = () => (
  <section className="description">
    <div className={styles.Headings}>
      <h1>I am Janvier Habineza</h1>
      <h2>Aspiring Software developer</h2>
    </div>
    <div className={styles.Text}>
      <p>
        I am a web developer. I focus on building web
        applications, and android applications using
        JavaScript language, and its technologies like
        NodeJs, React, React Native, and Redux.
      </p>
      {/* <p>
        A fullstack develper who enjoys cracking complex Challenges to be easy
        for Others. I enjoy interacting with people to share knowledge and
        experiences about web development.
      </p> */}
      <p>
        I like coding and I am very passionate about it.
        Whenever I have free time I play guitar and enjoy
        classic music, reading books mostly those talking
        about technology, and social life. I am passionate
        about what I do and a big fun of delivering quality
        work and learning more skills.
      </p>
      <p>
        As a growing developer, I always want to learn new
        skills and work on challenging projects so I can
        jump out of my comfort zone and grow
      </p>
    </div>
    <div className={styles.Navigation}>
      <Link to="./resume">
        <h3>More About me</h3>
      </Link>
    </div>
    <div className={styles.Icons}>
      <a
        href="https://github.com/Habinezajanvier"
        rel="noreferrer"
        target="_blank"
      >
        <GitHub />
      </a>
      <a
        href="https://twitter.com/habineza_jan"
        rel="noreferrer"
        target="_blank"
      >
        <Twitter />
      </a>
      <a
        href="https://www.linkedin.com/in/habineza-janvier-919160196/"
        rel="noreferrer"
        target="_blank"
      >
        <LinkedIn />
      </a>
    </div>
  </section>
);

export default Description;
